import { Fragment } from 'react';

import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { Combobox, HookForm } from '@dec/shared';
import { Col, Row } from '@dec/shared';
import { BtnGroup } from '@dec/shared';
import { BtnToolbar } from '@dec/shared';
import { notificationSuccess } from 'app/core/toast';
import { useGetAllTaxes } from 'app/modules/taxes/hooks/useTaxes';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';

import { ObjectRequired } from '../../../../../core/validations/common';
import { useOperationsList } from '../../../../Operations/EconomyActivity/hooks/useOperationsList';
import { type OperationTaxRequest, type TaxVector } from '../../models/types';
import { saveTaxOperation } from '../../services/http';
import { label } from '../../translation';

const validations = yup.object().shape({
  operation: ObjectRequired,
  tax: ObjectRequired
});

const Index = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const [{ data: operations, loading: loadingOperations, error: errroOperations }] =
    useOperationsList();

  const { data: taxes, loading: loadingTaxes, error: errorTaxes } = useGetAllTaxes();

  const saveTax = async (tax: TaxVector) => {
    try {
      await saveTaxOperation({
        operationId: tax.operation.id,
        taxId: tax.tax.id
      } as OperationTaxRequest);
      notificationSuccess(i18next.t('taxes.messages.savedSuccessfully'));
      navigate('/taxes/manage/operations');
    } catch (e) {
      console.error(e);
    }
  };

  const onCancel = () => {
    navigate('/taxes/manage/operations');
  };

  if (loadingOperations || errroOperations || loadingTaxes || errorTaxes) {
    return <></>;
  }

  return (
    <Fragment>
      <HookForm initialValues={{}} validations={validations} onSubmit={saveTax}>
        <Row>
          <Col>
            <Combobox label={label('tax')} name="tax" display="name" code="id" data={taxes} />
          </Col>
        </Row>
        <Row>
          <Col>
            <Combobox
              label={label('operation')}
              name="operation"
              display="name"
              code="id"
              data={operations}
            />
          </Col>
        </Row>

        <BtnToolbar>
          <BtnGroup>
            <Button action={ButtonAction.cancel} variant="secondary" onClick={onCancel} />
          </BtnGroup>
          <BtnGroup>
            <Button action={ButtonAction.save} variant="primary" type={'submit'} />
          </BtnGroup>
        </BtnToolbar>
      </HookForm>
    </Fragment>
  );
};

export default Index;
